// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-bottomtabbar-container{box-shadow:0px -5px 5px 0px rgba(34,35,43,0.2)}\n", ""]);
// Exports
module.exports = exports;
